import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockUIModule } from 'ng-block-ui';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import {
  MarketBasketDrugsComponent,
  MarketBasketDrugSearchComponent,
  MarketBasketTemplateModalHeaderComponent
} from './components';
import { DrugDaoService, MarketBasketTemplateDaoService } from './services/dao';
import { CompanyDaoService } from 'quantuvis-core-entities';

@NgModule({
  declarations: [
    MarketBasketDrugsComponent,
    MarketBasketTemplateModalHeaderComponent,
    MarketBasketDrugSearchComponent
  ],
  exports: [
    MarketBasketDrugsComponent,
    MarketBasketTemplateModalHeaderComponent,
    MarketBasketDrugSearchComponent
  ],
  providers: [
    MarketBasketTemplateDaoService,
    DrugDaoService,
    CompanyDaoService
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BlockUIModule,
    MatIconModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    MatDividerModule
  ]
})
export class MarketBasketCommonModule { }
